import { render, staticRenderFns } from "./KnowledgeBase.vue?vue&type=template&id=667e02e4&scoped=true"
import script from "./KnowledgeBase.vue?vue&type=script&lang=js"
export * from "./KnowledgeBase.vue?vue&type=script&lang=js"
import style0 from "./KnowledgeBase.vue?vue&type=style&index=0&id=667e02e4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667e02e4",
  null
  
)

export default component.exports